import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchHarvestProcess(organization_id, harvest_process_id) {
    return RequesterV1.get(
      `organization/production/productivity_by_producer_exp/show_process/${organization_id}/fetch_harvest_process/${harvest_process_id}`
    );
  },

  fetchProducers(organization_id, harvest_process_id, current_page, rows_per_page, filters = {}) {
    var str = Object.keys(filters)
      .filter(key => filters[key] != null)
      .map(key => {
        return `${key}=${encodeURIComponent(filters[key])}`
      })
      .join("&");
    return RequesterV1.get(
      `organization/production/productivity_by_producer_exp/show_process/${organization_id}/fetch_producers/${harvest_process_id}/${current_page}/${rows_per_page}?${str}`
    );
  },

  fetchTotalProducers(organization_id, harvest_process_id) {
    return RequesterV1.get(
      `organization/production/productivity_by_producer_exp/show_process/${organization_id}/fetch_total_producers/${harvest_process_id}`
    );
  },

  downloadRepProducersXlsx(organization_id, harvest_process_id) {
    return RequesterV1.get(
      `organization/production/productivity_by_producer_exp/show_process/${organization_id}/dowload_rep_producers_xlsx/${harvest_process_id}`,
      { responseType: "blob" }
    );
  }
};
